module.exports = __webpack_public_path__ + "f0c2ce4aa1d58887b706d7b28b340cec.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_3_a.png
// module id = 72
// module chunks = 0